import React from 'react';
import { Controller } from 'react-hook-form';
import {useFormProvider} from "../form-provider";

interface UploadProps {
    name: string
    placeholder?: string
    required?: boolean,
}

const Upload = ({
    name,
    placeholder,
    required,
}: UploadProps): JSX.Element => {
    const formProvider = useFormProvider();

    /*
    * TODO: More complete implementation later on
    * */

    return (
        <Controller
            name={name}
            control={formProvider?.control}
            rules={{
                required,
            }}
            render={({ field }) => (
                <input
                    type="file"
                    placeholder={placeholder || 'Upload'}
                    name={name}
                    value={field.value}
                    onChange={(event) => {
                        field.onChange(event);
                    }}
                />
            )}
        />
    );
};

export default Upload;
